import React from 'react';
import RangeSlider from '../RangeSlider';
import { conditionLabels } from '../../lib/constants';
import type { StepProps } from './types';

export default function ApartmentConditionStep({ 
  formData, 
  handleSliderChange 
}: StepProps) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">État de l'appartement</h3>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État de la cuisine
          </label>
          <RangeSlider
            value={parseInt(formData.etat_cuisine)}
            onChange={handleSliderChange('etat_cuisine')}
            labels={conditionLabels}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État de la salle de bain
          </label>
          <RangeSlider
            value={parseInt(formData.etat_salle_de_bain)}
            onChange={handleSliderChange('etat_salle_de_bain')}
            labels={conditionLabels}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État des sols
          </label>
          <RangeSlider
            value={parseInt(formData.etat_sols)}
            onChange={handleSliderChange('etat_sols')}
            labels={conditionLabels}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            État des fenêtres
          </label>
          <RangeSlider
            value={parseInt(formData.etat_fenetres)}
            onChange={handleSliderChange('etat_fenetres')}
            labels={conditionLabels}
          />
        </div>
      </div>
    </div>
  );
}